<template>
  <form @submit.prevent="handleSubmit" novalidate>
    <div class="form-group">
      <div class="title">
        <div class="tag hissu">必須</div>
        <div class="txt">電話番号</div>
      </div>
      <div class="box">
        <input
          type="tel"
          v-model="form.phone"
          placeholder="例：09012345678"
          :disabled="isLoading"
          maxlength="20"
          @input="onPhoneInput"
        />
        <p v-if="errors.phone" class="error-text">{{ errors.phone }}</p>
        <p style="margin-top: 0.25rem; font-size: 0.75rem; line-height: 1rem; color: #6b7280;">半角数字のみ、ハイフンなしで入力してください</p>
      </div>
    </div>

    <div class="form-group">
      <div class="title">
        <div class="tag hissu">必須</div>
        <div class="txt">メールアドレス</div>
      </div>
      <div class="box">
        <input
          type="email"
          v-model="form.email"
          placeholder="例：info_dr@m3career.com"
          :disabled="isLoading"
        />
        <p v-if="errors.email" class="error-text">{{ errors.email }}</p>
      </div>
    </div>

    <button
      type="button"
      class="comment_toggle"
      @click="showTextarea = !showTextarea"
      style="cursor: pointer; color: #1877b2; background: none; border: none; padding: 0;"
    >
      + ご希望・ご質問を入力する
    </button>

    <div v-if="showTextarea">
      <textarea
        v-model="form.message"
        class="fv-textarea"
        placeholder="50文字以内でご希望・ご質問内容をご記入ください。"
        rows="4"
        :disabled="isLoading"
      />
      <p v-if="errors.message" class="error-text">{{ errors.message }}</p>
    </div>

    <div class="form_annotation_box">
      <a href="/terms" target="_blank" rel="noopener noreferrer">利用規約</a>、
      <a href="https://www.m3career.com/privacy/" target="_blank" rel="noopener noreferrer">個人情報保護方針</a>
      に同意し、
    </div>

    <div class="slide_control_group">
      <a href="#" class="prev" @click.prevent="handleBack">＜ 戻る</a>
      <button type="submit" class="form_button_last" :disabled="isLoading">
        <span>無料で</span>
        登録する
      </button>
    </div>
  </form>
</template>

<script>
import { validatePhone, validateEmail } from '../../../lib/lp_gym01/validators'

export default {
  name: 'Step4Form',
  emits: ['submit', 'back'],
  props: {
    defaultValues: { type: Object, default: () => ({}) },
    isLoading: { type: Boolean, default: false }
  },
  data () {
    return {
      showTextarea: !!this.defaultValues.message,
      form: {
        phone: this.defaultValues.phone || '',
        email: this.defaultValues.email || '',
        message: this.defaultValues.message || ''
      },
      errors: {}
    }
  },
  methods: {
    onPhoneInput (e) {
      this.form.phone = e.target.value.replace(/[^\d]/g, '')
    },
    validate () {
      this.errors = {}
      if (!this.form.phone) {
        this.errors.phone = '正しい電話番号を入力してください'
      } else if (!validatePhone(this.form.phone)) {
        this.errors.phone = '正しい電話番号を入力してください'
      }
      if (!this.form.email) {
        this.errors.email = 'メールアドレスを入力してください'
      } else if (!validateEmail(this.form.email)) {
        this.errors.email = '有効なメールアドレスを入力してください（例: info_dr@m3career.com）'
      } else if (this.form.email.length > 80) {
        this.errors.email = '80文字以内で入力してください'
      }
      if (this.form.message && this.form.message.length > 50) {
        this.errors.message = 'ご希望・ご質問内容は50文字以内で入力してください'
      }
      return Object.keys(this.errors).length === 0
    },
    handleSubmit () {
      if (!this.validate()) return
      this.$emit('submit', { ...this.form })
    },
    handleBack () {
      this.$emit('back', { ...this.form })
    }
  }
}
</script>

<style scoped>
.error-text {
  margin-top: 4px;
  font-size: 12px;
  color: #ef4444;
}
</style>
